$(function() {

    // Navigation Functions =========================================== //

    // Fixed Navbar.
    if (!$('body').hasClass('page-template-ppc-competitor') && !$('body').hasClass('page-template-ppc-general') && !$('body').hasClass('page-template-state-of-1on1s') && !$('body').hasClass('page-template-teams-landing-page')) {

        var header = $('.site-header');

        $(window).scroll(function() {
            if ($(window).scrollTop() > 50) {
                header.addClass('navbar-fixed-top');
            } else {
                header.removeClass('navbar-fixed-top');
            }
        });

    }

    // Site Header Search Toggle.
    $(document).on('click', '.search-toggle', function() {
        $('.header-searchform-wrapper').toggle();
        $('.header-searchform-wrapper input[type="search"').focus();

        var icon = ($('.search-toggle i').html() == 'close') ? 'search' : 'close';
        $('.search-toggle i').html(icon);
    });

    //Hypercontext nav bar???
    function morphDropdown(element) {
        this.element = element;
        this.mainNavigation = this.element.find('.main-nav');
        this.mainNavigationItems = this.mainNavigation.find('.has-dropdown');
        this.dropdownList = this.element.find('.dropdown-list');
        this.dropdownWrappers = this.dropdownList.find('.dropdown');
        this.dropdownItems = this.dropdownList.find('.content');
        this.dropdownBg = this.dropdownList.find('.bg-layer');
        this.mq = this.checkMq();
        this.bindEvents();
    }
    morphDropdown.prototype.checkMq = function() {
        var self = this;

        return window.getComputedStyle(self.element.get(0), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "").split(', ');
    };
    morphDropdown.prototype.bindEvents = function() {
        var self = this;
        this.mainNavigationItems.mouseenter(function(event) {
            self.showDropdown($(this));
        }).mouseleave(function() {
            setTimeout(function() {
                if (self.mainNavigation.find('.has-dropdown:hover').length == 0 && self.element.find('.dropdown-list:hover').length == 0)
                    self.hideDropdown();
            }, 50);
        });
        this.dropdownList.mouseleave(function() {
            setTimeout(function() {
                (self.mainNavigation.find('.has-dropdown:hover').length == 0 && self.element.find('.dropdown-list:hover').length == 0) && self.hideDropdown();
            }, 50);
        });
        this.mainNavigationItems.on('touchstart', function(event) {
            var selectedDropdown = self.dropdownList.find('#' + $(this).data('content'));
            if (!self.element.hasClass('is-dropdown-visible') || !selectedDropdown.hasClass('active')) {
                event.preventDefault();
                self.showDropdown($(this));
            }
        });

        // Mobile open button
        $(document).on('click', '.nav-trigger', function(event) {
            event.preventDefault();
            $(this).toggleClass('mobile-button-close');
            self.element.toggleClass('nav-open');

            if ($('body,html').css('overflow') == 'clip') {
                $('body,html').css('overflow', '');
            } else {
                $('body,html').css('overflow', 'clip');
            }
        });
        $(document).on('click', '.hcmainnav_mobilebtn', function(event) {
            if ($(this).next().length) {

                event.preventDefault();
                $(this).toggleClass('hcmainnav_mobilebtn-active');

                if ($(this).hasClass('hcmainnav_mobilebtn-')) {
                    $(this).find('i').html('arrow_drop_up');
                } else {
                    $(this).find('i').html('arrow_drop_down');
                }
            }
        });
    };
    morphDropdown.prototype.showDropdown = function(item) {

        this.mq = this.checkMq();

        //if (this.mq == 'normal') {
        if (window.innerWidth > 999) {
            var self = this;
            var selectedDropdown = this.dropdownList.find('#' + item.data('content')),
                selectedDropdownHeight = selectedDropdown.innerHeight(),
                selectedDropdownWidth = selectedDropdown.children('.content').innerWidth(),
                selectedDropdownLeft = item.offset().left + item.innerWidth() / 2 - selectedDropdownWidth / 2;
            this.updateDropdown(
                selectedDropdown,
                parseInt(selectedDropdownHeight),
                selectedDropdownWidth,
                parseInt(selectedDropdownLeft)
            );
            this.element.find('.active').removeClass('active');
            selectedDropdown.addClass('active').removeClass('move-left move-right').prevAll().addClass('move-left').end().nextAll().addClass('move-right');
            item.addClass('active');
            if (!this.element.hasClass('is-dropdown-visible')) {
                setTimeout(function() {
                    self.element.addClass('is-dropdown-visible');
                }, 10);
            }
        }
    };
    morphDropdown.prototype.updateDropdown = function(dropdownItem, height, width, left) {

        var bodyWidth = $('body').width();

        if (left < 0) {
            responsiveLeft = 0;
        } else if ((left + width) > bodyWidth) {
            responsiveLeft = bodyWidth - width;
        } else {
            responsiveLeft = left;
        }

        this.dropdownList.css({
            '-moz-transform': 'translateX(' + responsiveLeft + 'px)',
            '-webkit-transform': 'translateX(' + responsiveLeft + 'px)',
            '-ms-transform': 'translateX(' + responsiveLeft + 'px)',
            '-o-transform': 'translateX(' + responsiveLeft + 'px)',
            'transform': 'translateX(' + responsiveLeft + 'px)',
            'width': width + 'px',
            'height': height + 'px'
        });

        $('.dropdown-list-tip').css(
            'left', ((width / 2) + (left))
        );
        8
        this.dropdownBg.css({
            '-moz-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            '-webkit-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            '-ms-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            '-o-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            'transform': 'scaleX(' + width + ') scaleY(' + height + ')'
        });
    };
    morphDropdown.prototype.hideDropdown = function() {
        this.mq = this.checkMq();
        //if (this.mq == 'normal') {
        if (window.innerWidth > 999) {
            this.element.removeClass('is-dropdown-visible').find('.active').removeClass('active').end().find('.move-left').removeClass('move-left').end().find('.move-right').removeClass('move-right');
        }
    };
    morphDropdown.prototype.resetDropdown = function() {
        this.dropdownList.removeAttr('style');
    };
    var morphDropdowns = [];
    if ($('.cd-morph-dropdown').length > 0) {
        $('.cd-morph-dropdown').each(function() {
            morphDropdowns.push(new morphDropdown($(this)));
        });
        var resizing = false;
        updateDropdownPosition();
        $(window).on('resize', function() {
            if (!resizing) {
                resizing = true;
                (!window.requestAnimationFrame) ? setTimeout(updateDropdownPosition, 300): window.requestAnimationFrame(updateDropdownPosition);
            }
        });

        function updateDropdownPosition() {
            morphDropdowns.forEach(function(element) {
                element.resetDropdown();
            });
            resizing = false;
        };
    }

    // ================================================================ //

    // Carousel/Slider Functions ====================================== //

    // Logos Slider.
    $('.logos').slick({
        mobileFirst: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 15000,
        infinite: true,
        cssEase: 'linear',
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }]
    });

    // Testimonials Slider.
    $('.testimonials').slick({
        mobileFirst: true,
        autoplay: true,
        autoplaySpeed: 8000,
        focusOnSelect: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20px',
        dots: true,
        arrows: false,
        responsive: [{
                breakpoint: 768,
                settings: {
                    centerPadding: '60px'
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    centerPadding: '300px'
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerPadding: '350px'
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '450px'
                }
            },
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '60px'
                }
            }
        ]
    });

    $('.testimonials_full').slick({
        mobileFirst: true,
        autoplay: true,
        autoplaySpeed: 8000,
        slidesToShow: 1,
        slidesPerRow: 1,
        centerMode: true,
        centerPadding: '20px',
        dots: true,
        arrows: true,
        prevArrow: '<div class="testimonials_arrow prevArrow"><span class="material-icons">chevron_left</span></div>',
        nextArrow: '<div class="testimonials_arrow nextArrow"><span class="material-icons">chevron_right</span></div>',
    });

    // Effective Meetings Slider.
    $('.effective-slider').slick({
        mobileFirst: true,
        dots: true,
        arrows: false,
        responsive: [{
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    centerPadding: '200px'
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    centerMode: true,
                    slidesToShow: 3
                }
            }
        ]
    });

    // ================================================================ //

    // Modal/Takeover Functions ======================================= //

    // Toggle Modal.
    $(document).on('click', '.toggle-modal, .video-toggle', function(e) {
        e.stopPropagation();

        var $this = $(this),
            videoUrl = $this.attr("data-video"),
            modalType = videoUrl ? 'VideoModal' : 'modal',
            $modal = $('#'+modalType),
            $iframe = $modal.find('iframe');

        $modal.show().toggleClass('website-modal--active');

        if($iframe.length && videoUrl){
            $iframe.attr('src', videoUrl);
        } else if($iframe.attr('src').length == 0 && $iframe.attr('data-src')) {
            $iframe.attr('src', $iframe.attr('data-src'));
        }

    });

    $(document).on('click', function(e) {
        var $target = $(e.target);

        if ($('.website-modal--active').length && $target.closest('.website-modal_content').length == 0) {
            $modal = $('.website-modal--active');
            $modal.removeClass('website-modal--active');
            $modal.find('iframe').attr('src', '');
        }

    });

    // Close Takeovers.
    $(document).on('click', '.takeover-close', function() {
        $('body').removeClass('active-takeover');
        $('.screen-takeover').removeClass('active');
    });

    // Dates.
    var today = Date.now();

    // Subscribe Takeover.
    if (window.location.href.indexOf('/blog') != -1) {

        var expiry_date = 1000 * 60 * 60 * 24 * 90;
        var $takeover = $('.screen-takeover');
        var subscribe_takeover = localStorage.getItem('subscribeTakeover');

        if (null == subscribe_takeover || expiry_date < today - subscribe_takeover) {

            localStorage.setItem('subscribeTakeover', today);

            setTimeout(function() {
                $('body').addClass('active-takeover');
                $takeover.addClass('active');
                $iframes = $takeover.find('iframe')
                if ($iframes.length > 0 && $iframes.attr('src').length == 0) {
                    $iframes.attr('src', $iframes.attr('data-src'));
                }
            }, 8000);

        }
    }



    // ================================================================ //

    // Tabs Functions ================================================= //

    // Features Meetings Tabs Toggle.
    if ($('body').hasClass('page-template-features-meetings')) {

        $(document).on('click', '.product-shot-tabs-title a', function(event) {
            event.preventDefault();

            if ($(window).width() >= 768) {
                var $this = $(this),
                    $row = $(this).closest('.row');

                $row.find('.is-active').removeClass('is-active');
                $row.find($this.attr('href')).addClass('is-active');
                $this.parent().addClass('is-active');

            }

        });

    }

    // Tabs Toggle.
    $(document).on('click', '.tabs-title a', function(event) {
        event.preventDefault();

        var $tab = $(this);
        var tab_anchor = $tab.attr('href');

        selectTab('.tabs-title a[href="' + tab_anchor + '"]', tab_anchor);

        if (history.pushState) {
            history.pushState(null, null, tab_anchor);
        }
    });

    // Popstate "Tabs"
    $(document).on('click', '.popstate-tabs-title a', function(event) {
        event.preventDefault();

        var $this = $(this);
        var replaceInsteadOfPop = $this.attr('data-replace-state');
        var tab_anchor = $this.attr('data-tab-content');

        selectTab('.popstate-tabs-title a[data-tab-content="' + tab_anchor + '"]', tab_anchor);

        if (history.replaceState && replaceInsteadOfPop) {
            history.replaceState({ tab_anchor: tab_anchor }, null, $this.attr('href'));
        } else if (history.pushState) {
            history.pushState({ tab_anchor: tab_anchor }, null, $this.attr('href'));
        }
    });

    function selectTab(selector, href) {
        var $tab = $(selector);

        $tab.parent().siblings().removeClass('is-active');
        $tab.parent().addClass('is-active');

        $(href).addClass('is-active').siblings().removeClass('is-active');

    }

    if (window.location.hash) {
        if ($('.tabs-title a[href="' + window.location.hash + '"]')) {
            selectTab('.tabs-title a[href="' + window.location.hash + '"]', window.location.hash);
        }

        if ($('.goal-example-card ' + window.location.hash + '')) {
            $('.goal-example-card ' + window.location.hash + '').parent().addClass('highlight');
        }
    }
    window.addEventListener('popstate', function(event) {
        if (document.location.pathname == '/goal-examples' && $('#departments-only').hasClass('display-none')) {
            toggleGoalExampleCategories();
        } else if (event && event.state && event.state.tab_anchor) {
            selectTab('.popstate-tabs-title a[data-tab-content="' + event.state.tab_anchor + '"]', event.state.tab_anchor);
            if ($('#department-and-roles').hasClass('display-none')) {
                toggleGoalExampleCategories();
            }
        }
    });
    window.addEventListener('hashchange', function() {
        selectTab('.tabs-title a[href="' + window.location.hash + '"]', window.location.hash);
    }, false);

    $(document).on('click', '#departments-only .popstate-tabs-title a', function(event) {
        toggleGoalExampleCategories();
    });

    $(document).on('click', '.goal-example-categories .section-label', function(event) {
        event.preventDefault();
        toggleGoalExampleCategories();
        if (history.pushState) {
            history.pushState(null, null, $(this).attr('href'));
        }
    });

    function toggleGoalExampleCategories() {
        $('#departments-only').toggleClass('display-none');
        $('#department-and-roles').toggleClass('display-none');
        setTimeout(function() {
            if ($('#departments-only').is(':visible')) {
                $('html, body').scrollTop($('#departments-only').filter(':visible').offset().top - 50);
            } else {
                $('html, body').scrollTop($('#department-and-roles .tabs-content.is-active').filter(':visible').offset().top - 100);
            }
        }, 1);
    }


    // ================================================================ //
    // Goal Examples Functions ======================================= //
    $('body').on('change', '.goal-example-card input', function() {
        var $card = $(this).closest('.goal-example-card');
        var totalMilestones = $card.find('input[type="checkbox"]').length;
        var completeMilestones = $card.find('input[type="checkbox"]:checked').length;

        if( 
            typeof confetti !== 'function'
            && 
            completeMilestones > 1
          ){
            $.ajax({
                url: "https://cdn.jsdelivr.net/npm/canvas-confetti@1.2.0/dist/confetti.browser.min.js",
                dataType: "script", cache: true
            }).done(function() {});
        }

        if (completeMilestones > 0 && totalMilestones > 0) {
            $card.find('.goal-example_progress').css('opacity', 1);
            $card.find('.goal-example_progress-bar').css('right', (1 - completeMilestones / totalMilestones) * 100 + "%");

            if (completeMilestones == totalMilestones) {
                $card.find('.goal-example_progress-bar').css('border-top-right-radius', "8px");
                setTimeout(function() {
                    var cardRect = $card[0].getBoundingClientRect();
                    var top = (cardRect.top - 10) / $(window).height();
                    var left = (cardRect.right) / $(window).width();

                    var variableNess = {
                        spread: (Math.floor(Math.random() * 40) + 70),
                        particleCount: (Math.floor(Math.random() * 60) + 70),
                        startVelocity: (Math.floor(Math.random() * 35) + 5),
                    }

                    confetti({
                        particleCount: variableNess.particleCount,
                        spread: variableNess.spread,
                        origin: { y: top, x: left },
                        angle: 0,
                        startVelocity: variableNess.startVelocity
                    });
                    $card.find('.goal-example_progress-bar').addClass('goal-example_progress-bar--complete');

                    $('#goal-example-conversion-test').show();
                }, 1000);

            } else {
                $card.find('.goal-example_progress-bar').css('border-top-right-radius', "0");
                setTimeout(function() {
                    $card.find('.goal-example_progress-bar').removeClass('goal-example_progress-bar--complete');
                }, 100);
            }
        } else {
            $card.find('.goal-example_progress').css('opacity', 0);
            $card.find('.goal-example_progress-bar').css('right', "100%");
            $card.find('.goal-example_progress-bar').css('border-top-right-radius', "0");
            setTimeout(function() {
                $card.find('.goal-example_progress-bar').removeClass('goal-example_progress-bar--complete');
            }, 100);
        }

    });


    // ================================================================ //

    // Agenda Template Functions ====================================== //

    // Featured pretend templates...

    var pretendTemplateLastAdvance = Date.now();
    queueNextPretendTemplateIteration();

    $('.pretend_template button[data-iterate="next"]').on('click', function() {
        nextPretendTemplate();
    });
    $('.pretend_template button[data-iterate="prev"]').on('click', function() {
        prevPretendTemplate()
    });

    function nextPretendTemplate() {
        pretendTemplateLastAdvance = Date.now();
        $('.pretend_template').each(function() {
            $(this).children().first().appendTo(this)
        });
    }

    function prevPretendTemplate() {
        pretendTemplateLastAdvance = Date.now();
        $('.pretend_template').each(function() {
            $(this).children().last().prependTo(this)
        });
    }

    function iteratePretendTemplates(force) {

        var now = Date.now(),
            lastAdvance = pretendTemplateLastAdvance;

        if (force || now > lastAdvance + 300) {
            nextPretendTemplate();
        }

        queueNextPretendTemplateIteration();

    }

    var queueNextPretendTemplateIterationTimer = null;

    function queueNextPretendTemplateIteration() {
        $('.intro-animation').remove();
        clearTimeout(queueNextPretendTemplateIterationTimer);
        queueNextPretendTemplateIterationTimer = setTimeout(function() {
            if ($('.pretend_template:hover').length == 0) {
                iteratePretendTemplates();
            } else {
                queueNextPretendTemplateIteration();
            }
        }, 5000);
    }

    // Agenda Template Collection Display

    $('.template_categories-title').on('click', function() {
        $(this).toggleClass('collapsed');
    });

    $('#agenda-template-collection input[type="search"]').on('keyup', function() {
        var search = $(this).val().toLowerCase();
        searchTemplates(search);
    });

    $('.template_categories-list a[data-category-key][data-category-value]').on('click', function(e) {
        e.preventDefault();
        var $this = $(this),
            categoryKey = $this.attr('data-category-key'),
            categoryValue = $this.attr('data-category-value'),
            href = $this.attr('href');

        navigateToCategory(categoryKey, categoryValue, href);

        return false;
    });
    $('.template_categories-select').on('change', function(e) {
        if ($(this).val() !== 'placeholder') {
            var $this = $(this),
                categoryString = $this.val().split("__"),
                categoryKey = categoryString[0],
                categoryValue = categoryString[1],
                href = `${document.location.origin}${document.location.pathname}?${categoryString[0]}=${categoryString[1]}`

            navigateToCategory(categoryKey, categoryValue, href);
        }
    });

    function searchTemplates(search) {
        selectTemplateCategory('search', 'search');
        $('.template_categories-select').val('placeholder')
        if (search) {
            $('.featured_cards.template_categories-item[data-keywords]').hide();
            $('.featured_cards.template_categories-item[data-keywords*="' + search + '"]').show();
        } else {
            $('.featured_cards.template_categories-item[data-keywords]').show();
        }


        if ($('.featured_cards.template_categories-item:visible').length == 0) {
            $('.template_categories-404').show();
            $('.template_categories-create').hide();
        } else {
            $('.template_categories-404').hide();
            $('.template_categories-create').show();
        }

    }

    function navigateToCategory(categoryKey, categoryValue, href) {
        $('#agenda-template-collection input[type="search"]').val('');
        selectTemplateCategory(categoryKey, categoryValue);

        if (history.replaceState) {
            history.replaceState({ categoryValue: categoryValue, categoryKey: categoryKey }, null, href);
        } else if (history.pushState) {
            history.pushState({ categoryValue: categoryValue, categoryKey: categoryKey }, null, href);
        }
    }

    function selectTemplateCategory(categoryKey, categoryValue) {
        $('.default_header_for_templates').hide();

        $('.template_categories-list a[data-category-key][data-category-value]').removeClass('active');
        $('.template_categories-list a[data-category-key="' + categoryKey + '"][data-category-value="' + categoryValue + '"]').addClass('active');

        $('.template_categories-item[data-categories]').hide();

        if ($('.template_categories-item[data-categories*="' + categoryKey + '__' + categoryValue + '"]').length > 0) {
            $('.template_categories-item[data-categories*="' + categoryKey + '__' + categoryValue + '"]').show();
        } else {
            $('.default_header_for_templates').show();
        }
        $([document.documentElement, document.body]).scrollTop(
            $("#agenda-template-collection").offset().top
        );


        if ($('.featured_cards.template_categories-item:visible').length == 0) {
            $('.template_categories-404').show();
            $('.template_categories-create').hide();
        } else {
            $('.template_categories-404').hide();
            $('.template_categories-create').show();
        }

    }


    window.addEventListener('popstate', function(event) {
        if (event && event.state && event.state.categoryKey && event.state.categoryValue) {
            selectTemplateCategory(categoryKey, categoryValue)
        }
    });

    $('.faq-accordian-item').on('click', function() {

        var $faq = $(this);

        $('.faq-accordian-item').not($faq).removeClass('open');
        $('.faq-accordian-item').removeClass('transparent-bottom-border');

        $faq.toggleClass("open");

        if ($faq.hasClass("open")) {
            $faq.prev().addClass('transparent-bottom-border')
        }

        return false;
    });

    $('.page-template-agenda-templates-detail a[data-slug][data-name][data-filetype]').on('click', function(){
        var slug = $(this).attr('data-slug'),
            name = $(this).attr('data-name'),
            filetype = $(this).attr('data-filetype');

        mixpanel.track("Template Service Download", {
            'Location': 'Marketing',
            'Template Name': name,
            'Template Slug': slug,
            'Template File': filetype
        });

        $('.cta-diversion').show();
        $('.cta-diversion .cta-diversion-manual-download').attr('href', `https://www.spinach.ai/i/${slug}-template.${filetype}`)
    });

    $('.cta-diversion').on('click', function(e) {
        $(this).hide();
    });
    $('.cta-diversion-card').on('click', function(e){
        e.stopPropagation();
    });


    // ================================================================ //

    // Pricing Page Functions ========================================= //

    // Mobile tabs.
    $('#tabsSelect').on('change', function() {
        $('.tabs-content').removeClass('is-active');
        $(this.value).addClass('is-active');
    });

    // Book time Demo Request.

    if ($('a[href^="https://calendly.com/spinach/"]')) {
        $('<link rel="stylesheet" type="text/css" href="https://assets.calendly.com/assets/external/widget.css" async defer>').appendTo("head");
        $('<script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async defer>').appendTo("head");
    }

    $(document).on('click', '#calendly-demo-request, a[href^="https://calendly.com/spinach/"]', function(e) {
        if (typeof Calendly !== 'undefined') {
            e.preventDefault();
            var $this = $(this),
                calendlyLink = 'https://calendly.com/spinach/hypercontext-by-spinach?hide_event_type_details=1';

            if ($this.attr('href') !== "#") {
                calendlyLink = $this.attr('href');
            }

            if (calendlyLink.indexOf('?') === -1) {
                calendlyLink += '?'
            }

            if (calendlyLink.indexOf('hide_event_type_details') === -1) {
                calendlyLink += '&hide_event_type_details=1'
            }

            if (calendlyLink.indexOf('utm_campaign') === -1) {
                calendlyLink += '&utm_campaign=calendly-link-' + ($('a[href^="https://calendly.com/spinach/"]').index($this)) + '-on-page';
            }

            if (calendlyLink.indexOf('utm_source') === -1) {
                calendlyLink += '&utm_source=' + (encodeURIComponent(document.location.href));
            }

            if (calendlyLink.indexOf('utm_medium') === -1) {
                calendlyLink += '&utm_medium=website';
            }

            Calendly.initPopupWidget({ url: calendlyLink });
        }
    });

    // ================================================================ //

    // Guides Functions =============================================== //

    // Generate Section Anchor Tags.
    if(/*'IntersectionObserver' in window &&*/ $('.anchor-navigation a[href]').length > 0 && $('.wp-block-group[id]').length > 0) {

        var anchorNavBoundingRects = {},
            anchorNavScrollOffset = 0
            anchorNavMobileNextPrev = {next:null, prev: null, current:null};

        updateAnchors();
        update_anchorNavBoundingRects();
        
        setInterval(function(){
            update_anchorNavBoundingRects();
            updateAnchors();
        }, 5000);
        

        window.addEventListener('scroll', function() {
            updateAnchors();
        }, {passive: true});

        
        function update_anchorNavBoundingRects(){
            var top = 0;
            var height = 0;
            $('.wp-block-group[id]').each(function(i, e){
                top = $(e).offset().top;
                height = $(e).outerHeight(true);
                anchorNavBoundingRects[this.id] = {
                    top: top,
                    height: height
                }
            });

            anchorNavScrollOffset = $(document).outerHeight(true) - (top + height);
        }
          
        function updateAnchors() {
          var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

          if(window.innerHeight > anchorNavScrollOffset){
            scrollPosition = scrollPosition + (window.innerHeight-anchorNavScrollOffset);
          }
      
          $.each(anchorNavBoundingRects, function(key, rect){
            var top = rect.top,
                height = rect.height,
                topPlusHeight = top + height;

            ///console.log(key, rect, scrollPosition)

            var read = topPlusHeight <= scrollPosition,
                reading = ((top <= scrollPosition) && (topPlusHeight >= scrollPosition)),
                percentRead = read ? 1 : 0;

            if(!read && reading) {
                percentRead = (scrollPosition - top) / height;
            }

            $('.anchor-navigation a[href="#'+key+'"]').attr({
                'data-read': read,
                'data-reading': reading,
                'data-percent-read': percentRead
            });

            if(reading){
                $('.anchor-navigation a[href="#'+key+'"] .reading-progress').width(percentRead*100+'%');
            }

            generate_anchorNav_nextPrev();
          });
        }

        function generate_anchorNav_nextPrev() {
    
            var $this = $('.heading-level-0 > a[data-reading="true"]').last(),
                $current = $this.closest('li'),
                $prev = $current.prev(),
                $next = $current.next();
    
            if($this.length == 0) {
                return false;
            }
    
            var prevHtml = '',
                nextHtml = '';
    
            var now = {
                prev: $prev.find('> a').attr('href'),
                current: $current.find('> a').attr('href'),
                next: $next.find('> a').attr('href'),
            }
    
            if(now.prev != anchorNavMobileNextPrev.prev || now.next !== anchorNavMobileNextPrev.next){
                anchorNavMobileNextPrev = {
                    prev: $prev.find('> a').attr('href'),
                    current: $current.find('> a').attr('href'),
                    next: $next.find('> a').attr('href'),
                };
            } else {
                return false;
            }
    
            if($prev.length > 0){
                prevHtml = `<a href="${$prev.find('> a').attr('href')}">Previous Section <div>${$prev.find('> a').attr('label')}</div></a>`;
            }
    
            if($next.length > 0){
                nextHtml = `<a href="${$next.find('> a').attr('href')}">Next Section <div>${$next.find('> a').attr('label')}</div></a>`;
            } else if( $prev.length > 0 ) {
                nextHtml = `<a class="signup" href="https://www.spinach.ai/ai-setup">About Spinach <div>Head to our homepage</div></a>`;
            }
    
            if($('#anchorNav_mobileTOC').length == 0) {
                $('<div id="anchorNav_mobileTOC"></div>').appendTo('body');
            }
    
    
            if($('#anchorNav_mobileTOC').is(':visible') && (prevHtml || nextHtml)){
                $('#anchorNav_mobileTOC').html(`
                    ${prevHtml}
                    ${nextHtml}
                `);
            } else {
                $('#anchorNav_mobileTOC').remove();
            }
    
    
        }
    } 

    // ================================================================ //

    // ================================================================ //

    // Miscellaneous Functions ======================================== //

    // Cookie Catapult.
    if (!$('body').hasClass('page-template-assistant')) {

        if (typeof catapultReadCookie !== 'undefined' && !catapultReadCookie("catAccCookies")) { // If the cookie has not been set then show the bar
            $("html").addClass("has-cookie-bar");
        }

    }

    // ================================================================ //

});

function copyToClipboard(text) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
}

$(".tab-nav").click(function() {
    var ID = $(this).data("id");
    $(".tab-nav, .tab-content").removeClass("active");
    $(this).addClass("active");
    $("#" + ID).addClass("active");
});


$(document).ready(function() {
    var sliderSpeed = $(".tabs-speed-data").data("speed");
    var s, i = $(".tab-nav"),
        e = $(".tab-content"),
        a = 0,
        r = sliderSpeed,
        n = !0,
        o = $(".tabs-slider");

    function c(n, s) {
        a = l(n, s), i.each(function() {
            var n = $(this);
            a === parseInt(i.index(n)) && n.addClass("active")
        })
    }

    function l(n, s) {
        return a = parseInt(n.index(s))
    }

    function u(n, s) {
        a = l(n, s), e.each(function() {
            var n = $(this);
            a === parseInt(e.index(n)) && n.addClass("active")
        })
    }

    function v() {
        i.removeClass("active");
        e.removeClass("active");
    }

    function f(n) {
        n.animate({
            width: "100%"
        }, {
            duration: r,
            easing: "linear"
        })
    }

    function d(n) {
        n.stop(), n.css({
            width: 0
        })
    }

    isMobile.phone || o[0] && VisSense(o[0], {
        fullyvisible: .6
    }).monitor({
        fullyvisible: function() {
            var t;
            n && (t = i.first(), f($(".progressBar", t)), s = setInterval(function() {
                var n = $(".tab-nav.active"),
                    s = n.next(".tab-nav");
                d($(".progressBar", n)), s.length ? (v(), f($(".progressBar", s)), c(i, s), u(i, s)) : (v(), f($(".progressBar", t)), c(i, t), u(i, t))
            }, r), n = !1)
        }
    }).start(), i.unbind().on("click", function(n) {
        d($(".progressBar")),
            function(n) {
                var s = !1;
                n.hasClass("active") || (s = !0);
                return s
            }($(this)) && (v(), c(i, $(this)), u(i, $(this))), clearInterval(s), n.stopPropagation()
    })
});